import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useNotifications, useTheme } from '@nbx/frontend-helpers/subscribe';
import { publishNotificationRemoved } from '@nbx/frontend-helpers/publish';
import styles from './styles.module.scss';

const NotificationProviderPortal = () => {
  return ReactDOM.createPortal(<NotificationProvider />, document.getElementById('notification_hook'));
};

const NotificationProvider = () => {
  const onNewNotification = ({ id, ttl }) => {
    setTimeout(() => {
      publishNotificationRemoved(id);
    }, ttl);
  };

  const notifications = useNotifications(onNewNotification);
  const theme = useTheme();

  return (
    <nbx-theme-provider theme={theme}>
      <div className={styles.notificationProvider}>
        <TransitionGroup component={React.Fragment}>
          {notifications.map(notification => {
            return (
              <CSSTransition
                classNames={{
                  enter: styles['notification-anim-enter'],
                  enterActive: styles['notification-anim-enter-active'],
                  exit: styles['notification-anim-exit'],
                  exitActive: styles['notification-anim-exit-active']
                }}
                timeout={550}
                key={notification.id}>
                <div className={styles.notificationWrapper}>
                  <nbx-notification-popup
                    type={notification.type}
                    heading={
                      notification.title ??
                      `${notification.type.substr(0, 1).toUpperCase()}${notification.type.substr(1)}`
                    }
                    text={notification.message}
                    onClick={() => {
                      notification.onDismiss?.();
                      publishNotificationRemoved(notification.id);
                    }}
                  />
                </div>
              </CSSTransition>
            );
          })}
        </TransitionGroup>
      </div>
    </nbx-theme-provider>
  );
};

export default NotificationProviderPortal;
